'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';

const CONSENT_KEY = 'cookie-consent-accepted';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show banner if no consent decision has been made
    if (!localStorage.getItem(CONSENT_KEY)) {
      setVisible(true);
    }
  }, []);

  function accept() {
    localStorage.setItem(CONSENT_KEY, 'true');
    setVisible(false);
  }

  function decline() {
    localStorage.setItem(CONSENT_KEY, 'false');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      id="cookie-consent"
      role="dialog"
      aria-modal="true"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg p-4 sm:p-5"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm text-gray-700 flex-1">
          We use cookies for analytics and to improve your experience. By clicking &ldquo;Accept&rdquo; you consent to our use of cookies.
          See our{' '}
          <Link href="/privacy" className="text-[#2813e8] hover:text-[#1f0fb8]" style={{ textDecoration: 'underline' }} aria-label="Read our privacy policy">
            privacy policy
          </Link>.
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={decline}
            className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Decline cookies
          </button>
          <button
            onClick={accept}
            className="px-4 py-2 text-sm font-medium text-white bg-[#2813e8] rounded-lg hover:bg-[#1f0fb8] transition-colors"
          >
            Accept cookies
          </button>
        </div>
      </div>
    </div>
  );
}
